<div class="closure-container">
  <h6 class="fw-medium text-dark mb-4">
    ¿De qué modo deseas enviar el cierre?
  </h6>

  <div class="details-container">
    <h6 class="details-title text-center text-uppercase">Detalles del Envío</h6>

    <div class="details-content">
      <div class="detail-row">
        <span class="detail-label">Agente:</span>
        <span class="detail-value">{{ agent }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Mes:</span>
        <span class="detail-value text-capitalize">{{ month }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Valor:</span>
        <span class="detail-value">${{ value | number : "1.2-2" }} </span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Encargado:</span>
        <span class="detail-value">{{ supervisor }}</span>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center gap-3 mt-3">
    <button
      type="button"
      class="btn btn-sm btn-primary text-nowrap"
      (click)="onSendApp()"
    >
      Enviar App
    </button>

    <button
      type="button"
      class="btn btn-sm btn-success text-nowrap"
      (click)="onSendDirect()"
    >
      Envío Directo
    </button>

    <button
      type="button"
      class="btn btn-sm btn-dark text-nowrap"
      (click)="onSendClosureZG()"
    >
      Enviar Cierre ZG
    </button>
  </div>
</div>
